<div id="browserToSmallScreen" class="flexColumnContainer">
  <h3 id="browserToSmallScreenTitle">{{ 'browserToSmallScreen.title' | translate }}</h3>
  <p id="browserToSmallScreenText">{{ 'browserToSmallScreen.description' | translate }}</p>
</div>
<app-header></app-header>
<div id="sideNavAndContent" class="flexRowContainer">
  <app-side-navigation [ngClass]="{'hidden': !authenticatedAndTeamChosen}"></app-side-navigation>
  <mat-drawer-container id="appContent" [ngClass]="{'loading': loadingSpinnerService.spinnerVisible$ | async}"
                        hasBackdrop="false">
    <mat-drawer-content id="mainDrawerContent">
      @if (loadingSpinnerService.spinnerVisible$ | async) {
        <div id="spinnerContainer">
          <mat-spinner/>
        </div>
      }
      <router-outlet/>
    </mat-drawer-content>
    <mat-drawer id="rightSideDrawer" #rightSideDrawer position="end" mode="side" width="320px">
      <div id="rightSideDrawerContent" class="flexColumnContainer">
        @switch (activePanel()) {
          @case ('comments') {
            <app-comments (closed)="rightSideDrawer.close()"></app-comments>
          }
          @case ('data') {
            <app-case-data (closed)="rightSideDrawer.close()"></app-case-data>
          }
          @case ('actions') {
            <app-case-actions (closed)="rightSideDrawer.close()"></app-case-actions>
          }
          @case ('audit') {
            <app-audit-history (closed)="rightSideDrawer.close()"></app-audit-history>
          }
        }
      </div>
    </mat-drawer>
  </mat-drawer-container>
  <div id="rightSideNavigation" class="flexColumnContainer"
       [ngClass]="{'hidden': !isPanelView || !anyPanelEnabled()}">
    @if (commentsEnabled()) {
      <button mat-icon-button (click)="togglePanel('comments')" (keydown.enter)="togglePanel('comments')"
              [class.active]="rightSideDrawer.opened && activePanel() === 'comments'">
        <mat-icon class="material-symbols-outlined">sticky_note_2</mat-icon>
      </button>
    }
    @if (customDataEnabled()) {
      <button mat-icon-button (click)="togglePanel('data')" (keydown.enter)="togglePanel('data')"
              [class.active]="rightSideDrawer.opened && activePanel() === 'data'">
        <mat-icon class="material-symbols-outlined">data_object</mat-icon>
      </button>
    }
    @if (customActionsEnabled()) {
      <button mat-icon-button (click)="togglePanel('actions')" (keydown.enter)="togglePanel('actions')"
              [class.active]="rightSideDrawer.opened && activePanel() === 'actions'">
        <mat-icon class="material-symbols-outlined">bolt</mat-icon>
      </button>
    }
    @if (auditEnabled()) {
      <button mat-icon-button (click)="togglePanel('audit')" (keydown.enter)="togglePanel('audit')"
              [class.active]="rightSideDrawer.opened && activePanel() === 'audit'"
              [attr.aria-label]="'audit.title' | translate">
        <mat-icon class="material-symbols-outlined">history</mat-icon>
      </button>
    }
  </div>
</div>
<div id="background"></div>
<div id="footerBackground">
</div>
